import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import isArray from 'lodash/isArray';
import './Select.scss';

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.placeholder && !props.value ? '' : props.value,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  handleChange(e) {
    const text = e.target.value;
    this.setState({
      value: text,
    });

    this.props.onChange(e);
  }

  render() {
    const {
      options,
      name,
      disabled,
      value,
      label,
      className,
      placeholder,
      errors,
      onClick,
      infoText,
      emptyDefault,
      icon,
    } = this.props;
    const selectErrors = isArray(errors) ? errors : errors ? [errors] : null;

    return (
      <div
        className={`Select input-container ${selectErrors ? 'error' : ''} ${className}`}
        onClick={onClick}>
        {label && (
          <label htmlFor={name} className="w-100">
            {this.props.t(label)}
          </label>
        )}
        <select
          className={`${value ? '' : 'placeholder'} `}
          name={name}
          value={this.state.value}
          onChange={this.handleChange}
          disabled={disabled}>
          {placeholder || emptyDefault ? (
            <option value="" className="d-none">
              {placeholder}
            </option>
          ) : null}
          {options.map((option) => (
            <option
              key={`option-${option.value || option}`}
              value={option.value || option}
              disabled={option.disabled || false}>
              {option.label || option}
            </option>
          ))}
        </select>
        {icon ? icon : <i className="fa fa-chevron-down" />}
        {infoText && (!selectErrors || !selectErrors.length) && (
          <span className="info-text font-size-12">{infoText}</span>
        )}
        {selectErrors?.map((error) => (
          <span className="text-error font-size-12" key={error}>
            {this.props.t(error)}
          </span>
        ))}
      </div>
    );
  }
}

Select.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])),
  placeholder: PropTypes.string,
  emptyDefault: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

Select.defaultProps = {
  label: '',
  className: '',
  placeholder: '',
  emptyDefault: false,
};

export default withTranslation()(Select);
